var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 892,
    height: 545,
    viewBox: "0 0 892 545",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440 444C440 439.582 443.582 436 448 436H872C876.418 436 880 439.582 880 444V537C880 541.418 876.418 545 872 545H448C443.582 545 440 541.418 440 537V444Z",
    fill: "#F0811D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H432C436.418 0 440 3.58172 440 8V101C440 105.418 436.418 109 432 109H7.99999C3.58171 109 0 105.418 0 101V8Z",
    fill: "#003F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111 117C111 112.582 114.582 109 119 109H543C547.418 109 551 112.582 551 117V210C551 214.418 547.418 218 543 218H119C114.582 218 111 214.418 111 210V117Z",
    fill: "#76B900"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220 226C220 221.582 223.582 218 228 218H652C656.418 218 660 221.582 660 226V319C660 323.418 656.418 327 652 327H228C223.582 327 220 323.418 220 319V226Z",
    fill: "#FB4747"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M331 335C331 330.582 334.582 327 339 327H763C767.418 327 771 330.582 771 335V428C771 432.418 767.418 436 763 436H339C334.582 436 331 432.418 331 428V335Z",
    fill: "#883C8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.170ac67dbf62267e45bcd6b207bd2dfd.svg";
export { ForwardRef as ReactComponent };